import request from 'superagent';
import { addError } from './utils';
import { startLoad, finishLoad } from './loader';

function receiveProjects(projects) {
  return {
    type: 'RECEIVE_PROJECTS',
    projects,
  };
}

function receivePendingProjects(projects) {
  return {
    type: 'RECEIVE_PENDING',
    projects,
  };
}

export function receiveProject(project) {
  return {
    type: 'RECEIVE_PROJECT',
    project,
  };
}

export function getProjects(lang) {
  return dispatch => {
    dispatch(startLoad('getProjects', 'Загрузка проектов'));
    request.post(`/project/list/${lang}`).end((err, res) => {
      dispatch(finishLoad('getProjects'));
      if (err) {
        dispatch(receiveProjects(null));
      } else {
        dispatch(receiveProjects(res.body.data));
        dispatch(getPendingProjects(lang));
      }
    });
  };
}

export function saveProject(project) {
  return dispatch => {
    dispatch(startLoad('saveProject', 'Сохранение проекта'));
    request
      .post('/project/save')
      .send(project)
      .end((err, res) => {
        dispatch(finishLoad('saveProject'));
        if (err) {
          dispatch(addError(err));
        } else {
          dispatch(getProjects(project.lang));
          dispatch(receiveProject(res.body.project));
        }
      });
  };
}

export function deleteProject(project) {
  return dispatch => {
    dispatch(startLoad('removeProject', 'Удаление проекта'));
    request.delete(`/project/${project.name}`).end((err, res) => {
      dispatch(finishLoad('removeProject'));
      if (err) {
        dispatch(addError(err));
      } else {
        dispatch(receiveProjects(res.body.data));
      }
    });
  };
}

export function shareProject(name, code, target, lang) {
  return dispatch => {
    dispatch(startLoad('shareProject', 'Делимся проектом'));
    request
      .post('/project/share')
      .send({ name, code, target, lang })
      .end((err, res) => {
        dispatch(finishLoad('shareProject'));
        if (err) {
          dispatch(addError(err));
        } else {
          //dispatch(getProjects(project.lang));
          //dispatch(receiveProject(res.body.savedProject));
        }
      });
  };
}

export function getPendingProjects(lang) {
  return dispatch => {
    dispatch(startLoad('getPendingProjects', 'Загрузка ожидающих проектов'));
    request.post(`/project/list/${lang}/pending`).end((err, res) => {
      dispatch(finishLoad('getPendingProjects'));
      if (err) {
        dispatch(receivePendingProjects(null));
      } else {
        dispatch(receivePendingProjects(res.body.data));
      }
    });
  };
}

export function accept(id) {
  return dispatch => {
    dispatch(startLoad('acceptProject', 'Принимаем проект'));
    request
      .post('/project/accept')
      .send({ id })
      .end((err, res) => {
        dispatch(finishLoad('acceptProject'));
        if (err) {
          dispatch(addError(err));
        } else {
          dispatch(receiveProject(res.body.project));
          dispatch(getProjects(res.body.project.lang));
        }
      });
  };
}

export function decline(id) {
  return dispatch => {
    dispatch(startLoad('declineProject', 'Отклоняем проект'));
    request
      .post('/project/decline')
      .send({ id })
      .end((err, res) => {
        dispatch(finishLoad('declineProject'));
        if (err) {
          dispatch(addError(err));
        }
      });
  };
}
